<template>
  <div class="mask" v-if="show"> <!--//取消预约弹框-->
    <div class="alertBox">
      <!--<div class="close" @click="cancel"></div>-->
      <div class="tips">{{titleStr}}</div>
      <div class="btnWrapper clearfix">
        <input type="button" class="btn l make themeBg" @click="cancel" value="取消" />
        <input type="button" class="btn r" value="重新登录" @click="login"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {CommonUtil} from '../common/CommonUtil.js';
  import {StorageUtil} from '../common/Auth'
  import {store} from '../store/store'
  import Vue from 'vue'
  export default {
    name: 'repeatlogin',
    data() {
      return {
        show: false,
        titleStr: "账号已在其他设备登录，请确认是否本人操作!",
        libCode: '',
      }
    },
      beforeMount(){
        this.libCode = this.$route.query.hallCode || this.$route.query.libCode || '';
      },
    methods: {
      cancel() {
        store.user = null
        StorageUtil.removeObject('user');
        this.$emit('cancel');
        this.show = false;
        location.reload();
      },
       login() {
        this.show = false;
        CommonUtil.saveRepeatLoginUrl();
        store.wrap.user = null
        store.index.$refs.login.showLogin()
        // setTimeout(store.index.$refs.login.showLogin(),5000)
       
      },
      isShow(type) {
        if(type==1){
          this.titleStr="由于你长时间没有操作，请重新登录!";
        }else if(type==2){
            this.titleStr="登录超时，请重新登录!";
        }else{//0
            this.titleStr="账号已在其他设备登录，请确认是否本人操作!";
        }
        this.show = true;
      }
    }
  }
</script>

<style scoped lang="sass">
  .btnWrapper
    display: inline-block
    width: 292px
    height: 50px


  .tips
    margin: 40px 0 28px
    font-size: 19px
    line-height: 40px


  .btn
    width: 139px
    height: 43px
    font-size: 16px
    line-height: 45px
    text-align: center
    border: 1px solid $themecolor1
    border-radius: 4px
    background: #fff
    color: $themecolor1
    cursor: pointer


  .make
    color: #fff

</style>
